import Entity from "@/assets/js/JMan";

const nominatimSearchFormattedObject = (o) => {
	let n = ["road", "locality", "suburb", "village", "town", "city", "postcode", "country_code"].map(e => {
		return e == "country_code" ? o.address[e].toUpperCase() : o.address[e]
	}).filter( (e, i, a) => {
		return !!e && (a.indexOf(e) == i)
	}).join(", ");

	let html = (n.length > 2) ? `<span title="${o.display_name}">${n}</span>` : o.display_name;
	if (o.lat && o.lon) {
		html += ` <small><a href="https://www.openstreetmap.org/?mlat=${o.lat}&mlon=${o.lon}#map=12/${o.lat}/${o.lon}" target="_blank" title="View on a map" onclick="let e = arguments[0]; e.stopPropagation()">ϕ ${Number(o.lat).toFixed(3)}, λ ${Number(o.lon).toFixed(3)}</a></small> <small style="color: gray;">Nominatim</small>`
	}

	return {
		display: n || o.display_name,
		html,
		value: {
			data: {
				name: n || o.display_name,
				geo: { latitude: o.lat, longitude: o.lon }
			}
		}
	}
}

const nominatimSearch = {
	query: "https://nominatim.openstreetmap.org/?format=json&addressdetails=1&q={query}&limit=10",
	result: (o) => nominatimSearchFormattedObject(o)
};

const directCoordinatesInput = (search) => {
	const rxLat = /^(\+|-)?(?:90(?:(?:\.0{1,16})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,16})?))$/;
	const rxLon = /^(\+|-)?(?:180(?:(?:\.0{1,16})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,16})?))$/;

	const possible = search.split(":").pop();
	if (true || possible != search) { // FIXME The true || is to allow matches in the absence of a name
// 		console.log("possible", possible);
		const pair = possible.trim().split(/\s*,\s*/);
// 		console.log("pair", pair);
		if (pair.length == 2) {
			let lat = rxLat.exec(pair[0]);
			let lon = rxLon.exec(pair[1]);
// 			console.log("lat, lon", lat, lon)
			if (lat && lon && lat.length && lon.length) {
				lat = Number(lat[0]);
				lon = Number(lon[0]);
				const name = possible != search ?search.match(/^(.*):.*$/)[1].trim() : search;
				const html = `<span>${name}</span> <small><a href="https://www.openstreetmap.org/?mlat=${lat}&mlon=${lon}#map=12/${lat}/${lon}" target="_blank" title="View on a map" onclick="let e = arguments[0]; e.stopPropagation()">ϕ ${lat.toFixed(3)}, λ ${lon.toFixed(3)}</a></small>`;

// 				console.log("match");
				return [{
					display: name,
					html,
					value: {
						data: {
							name: name,
							geo: { latitude: lat, longitude: lon }
						}
					}
				}];
			}
		}
	}
// 	console.log("no match", possible, search);
	return [];
};

const dbLocationResults = (prop, srcLabel) => {
	return (o) => {
		const objectData = prop ? o.data[prop] : o;
		let geo = objectData.data && objectData.data.geo;
		const display = objectData.name || (
			objectData.data && objectData.data.name
		) || objectData;
		const value = objectData;
		let html = `<span>${display}</span>`;
		if (geo) {
			geo.latitude = Number(geo.latitude);
			geo.longitude = Number(geo.longitude);
			html += ` <small><a href="https://www.openstreetmap.org/?mlat=${geo.latitude}&mlon=${geo.longitude}#map=12/${geo.latitude}/${geo.longitude}" target="_blank" title="View on a map" onclick="let e = arguments[0]; e.stopPropagation()">ϕ ${geo.latitude.toFixed(3)}, λ ${geo.longitude.toFixed(3)}</a></small>`;
		}
		if (srcLabel) {
			html += ` <small style="color: gray">${srcLabel}</small>`;
		}

		return {
			display,
			html,
			value
		};
	};
};

export const driver = {
	model: "driver",
	label: "Driver",
	type: "text",
	maxItems: 50,
	attrs: {
		autocapitalize: "words",
		placeholder: "Driver name"
	},
	searchUriTemplate: [
		{
			query: "{api}/person?fields=name:%25{query}%25;email:%25{query}%25;handle:%25{query}%25&limit=10",
			result (o) {
				const ent = Entity.make(o);
				let display = ent.displayName();
				let html = ent.displayName();
				if (ent.data.name.join) {
					o.data.name.shift();
					html += ` <small>${o.data.name.join(", ")}</small>`;
				}
				html += ` <small>${o.data.handle || ""} ${o.data.email || ""} ${o.data.phone || ""}<small>`;
				let value = o.id;
				return {
					display,
					html,
					value
				}
			}
		},
		{
			query: "{api}/journey?fields=driver:%25{query}%25&limit=10",
			display: (o) => o.data.driver,
			value: (o) => o.data.driver
		}
	]
};

export const vehicle = {
	model: "vehicle",
	label: "Vehicle",
	type: "text",
	maxItems: 50,
	attrs: {
		autocapitalize: "words",
		placeholder: "Vehicle name, registration or description"
	},
	searchUriTemplate: [
		{
			query: "{api}/asset?fields=name:%25{query}%25;email:%25{query}%25;handle:%25{query}%25&limit=10",
			display: (o) => o.data.name,
			value: (o) => o.id
		},
		{
			query: "{api}/journey?fields=vehicle:%25{query}%25&limit=10",
			display: (o) => o.data.vehicle,
			value: (o) => o.data.vehicle
		}
	]
};

export const origin = {
	model: "origin",
	label: "Origin",
	type: "text",
	attrs: {
		autocapitalize: "sentences",
		placeholder: "Origin name, address or description"
	},
	searchUriTemplate: [
		{
			query: "{api}/location?fields=name:%25{query}%25;email:%25{query}%25;handle:%25{query}%25&limit=10",
			result: dbLocationResults(null, "Location")
		},
		{
			query: "{api}/journey?fields=origin:%25{query}%25&limit=10",
			result: dbLocationResults("origin", "Journey")
		},
		{
			query: "{api}/journey?fields=destination:%25{query}%25&limit=10",
			result: dbLocationResults("destination", "Journey")
		},
		directCoordinatesInput,
		nominatimSearch
	]
};

export const destination = {
	model: "destination",
	label: "Destination",
	type: "text",
	attrs: {
		autocapitalize: "sentences",
		placeholder: "Destination name, address or description"
	},
	searchUriTemplate: [
		{
			query: "{api}/location?fields=name:%25{query}%25;email:%25{query}%25;handle:%25{query}%25&limit=10",
			result: dbLocationResults(null, "Location")
		},
		{
			query: "{api}/journey?fields=origin:%25{query}%25&limit=10",
			result: dbLocationResults("origin", "Journey")
		},
		{
			query: "{api}/journey?fields=destination:%25{query}%25&limit=10",
			result: dbLocationResults("destination", "Journey")
		},
		directCoordinatesInput,
		nominatimSearch
	]
};

export const waypoint = {
	model: "waypoint",
	label: "Waypoints",
	component: "jm-edit-waypoint",
	maxItems: 1000,
	hideEmpty: true
}

export const atd = {
	model: "atd",
	label: "ATD",
	title: "Actual time of departure",
	type: "datetime-local",
	attrs: {
		placeholder: "Actual time of departure"
	}
};

export const etd = {
	model: "etd",
	label: "ETD",
	title: "Estimated time of departure",
	type: "datetime-local",
	attrs: {
		placeholder: "Estimated time of departure"
	}
};

export const std = {
	model: "std",
	label: "STD",
	title: "Scheduled time of departure",
	type: "datetime-local",
	attrs: {
		placeholder: "Scheduled time of departure"
	}
};

export const ata = {
	model: "ata",
	label: "ATA",
	title: "Actual time of arrival",
	type: "datetime-local",
	attrs: {
		placeholder: "Actual time of arrival"
	}
};

export const eta = {
	model: "eta",
	label: "ETA",
	title: "Estimated time of arrival",
	type: "datetime-local",
	attrs: {
		placeholder: "Estimated time of arrival"
	}
};

export const sta = {
	model: "sta",
	label: "STA",
	title: "Scheduled time of arrival",
	type: "datetime-local",
	attrs: {
		placeholder: "Scheduled time of arrival"
	}
};

export const departure = {
	key: "departure",
	label: "Departure",
	subgroup: [
		atd,
		etd,
		std
	]
};

export const arrival = {
	key: "arrival",
	label: "Arrival",
	subgroup: [
		ata,
		eta,
		sta
	]
};

export const distance = {
	key: "distance",
	label: "Distance",
	type: "number",
	title: "Journey distance, derived from odometer readings",
	value: (entity) => entity.computed.distance()
}

export const delay = {
	key: "delay",
	label: "Delay",
	type: "time",
	title: "Delay respect to estimated / scheduled arrival",
	value: (entity) => entity.computed.delay()
};

export const ad = {
	key: "ad",
	label: "Actual duration",
	type: "time",
	title: "Actual duration of journey",
	value: (entity) => entity.computed.ad()

};

export const ed = {
	key: "ed",
	label: "Estimated duration",
	type: "time",
	title: "Estimated duration of journey",
	value: (entity) => entity.computed.ed()
};

export const sd = {
	key: "sd",
	label: "Scheduled duration",
	type: "time",
	title: "Scheduled duration of journey",
	value: (entity) => entity.computed.sd()
};

export const pax = {
	model: "pax",
	label: "Passengers",
	title: "List of passengers",
	type: "text",
	maxItems: 1000,
	hideEmpty: true,
	attrs: {
		autocapitalize: "sentences",
		placeholder: "Passenger name"
	},
	searchUriTemplate: [
		{
			query: "{api}/person?fields=name:%25{query}%25;email:%25{query}%25;handle:%25{query}%25&limit=10",
			display: (o) => o.data.name,
			value: (o) => o.id
		},
		{
			query: "{api}/journey?fields=pax:%25{query}%25&limit=10",
			display: (o) => o.data.pax,
			value: (o) => o.data.pax
		}
	]
};

export const supervisor = {
	model: "supervisor",
	label: "Journey supervisor",
	title: "A person not involved in the trip who is responsible for following and monitoring its progresss",
	type: "text",
	maxItems: 10,
	attrs: {
		autocapitalize: "words",
		placeholder: "Supervisor name"
	},
	searchUriTemplate: [
		{
			query: "{api}/person?fields=name:%25{query}%25;email:%25{query}%25;handle:%25{query}%25&limit=10",
			display: (o) => o.data.name,
			value: (o) => o.id
		},
		{
			query: "{api}/journey?fields=supervisor:%25{query}%25&limit=10",
			display: (o) => o.data.supervisor,
			value: (o) => o.data.supervisor
		}
	]
};

export const purpose = {
	model: "purpose",
	label: "Journey purpose",
	title: "Brief description of the reason for this journey",
	type: "text",
	hideEmpty: true,
	attrs: {
		autocapitalize: "sentences",
		placeholder: "Description of the purpose of this journey"
	}
};

export const tags = {
	model: "tags",
	label: "Tags",
	title: "",
	type: "text",
	maxItems: 50,
	hideEmpty: true,
	attrs: {
		pattern: "[a-z0-9:-]*"
	},
	searchUriTemplate: [
		{
			query: "{api}/journey?fields=tags:%25{query}%25&limit=10",
			display: (o) => o,
			value: (o) => o
		}
	]
};

export const remarks = {
	model: "remarks",
	label: "Remarks",
	title: "General remarks",
	type: "textarea",
	hideEmpty: true,
	attrs: {
		placeholder: "Free text, Markdown enabled"
	}
};

export const brief = {
	model: "brief",
	label: "Pre-departure brief",
	title: "Summary of pre-departure discussion of routes, stops, hazards, loads, safe speeds, contingency plans, etc.",
	type: "textarea",
	hideEmpty: true,
	attrs: {
		placeholder: "Free text, Markdown enabled"
	}
};

export const debrief = {
	model: "debrief",
	label: "Post-arrival debrief",
	title: "Summary of discussion of difficulties, unexpected risks or other abnormal situations encountered during the trip",
	type: "textarea",
	hideEmpty: true,
	attrs: {
		placeholder: "Free text, Markdown enabled"
	}
};

export const phone = {
	model: "phone",
	label: "Phone number",
	title: "Contact telephone number",
	type: "tel",
	maxItems: 100,
	hideEmpty: true,
	attrs: {
		placeholder: "Phone number in international format"
	}
};

export const email = {
	model: "email",
	label: "Email",
	title: "Contact email address",
	type: "email",
	maxItems: 100,
	hideEmpty: true,
	attrs: {
		placeholder: "Email address"
	}
};

export const webUrl = {
	model: "webUrl",
	label: "Website",
	title: "Location of a descriptive website for this entity",
	type: "url",
	maxItems: 100,
	hideEmpty: true,
	attrs: {
	}
};

export const mapUrl = {
	model: "mapUrl",
	label: "Map URL",
	title: "Location of a map depicting the planned itinerary for this journey",
	type: "url",
	maxItems: 100,
	hideEmpty: true,
	attrs: {
	}
};

export const trackerUrl = {
	model: "trackerUrl",
	label: "Tracker URL",
	title: "Location from which this entity may be tracked (in real time or not)",
	type: "url",
	maxItems: 100,
	hideEmpty: true,
	attrs: {
	}
};

export const gpxRouteUrl = {
	model: "gpxRouteUrl",
	label: "GPX route URL",
	title: "Location of a GPX file with the planned itinerary for this journey",
	type: "url",
	maxItems: 100,
	hideEmpty: true,
	attrs: {
	}
};

export const gpxTrackUrl = {
	model: "gpxTrackUrl",
	label: "GPX track URL",
	title: "Location of a GPX file with a track log of this journey",
	type: "url",
	maxItems: 100,
	hideEmpty: true,
	attrs: {
	}
};

export const odometer = {
	key: "odometer",
	label: "Odometer",
	title: "Odometer readings at start / end of the journey",
	hideEmpty: true,
	subgroup: [
		{
			model: "odometerStart",
			label: "Odometer start",
			type: "number",
			attrs: {
				min: 0,
				placeholder: "Reading at start of journey"
			}
		},
		{
			model: "odometerEnd",
			label: "Odometer end",
			type: "number",
			attrs: {
				min: 0,
				placeholder: "Reading at end of journey"
			}
		}
	]
};

export const name = {
	model: "name",
	label: "Name",
	type: "text",
	maxItems: 10,
	attrs: {
		autocapitalize: "words",
		placeholder: "Enter a name"
	}
};

export const handle = {
	model: "handle",
	label: "Handle",
	type: "text",
	attrs: {
		placeholder: "Enter a short word (only lowercase letters and numbers)",
		pattern: "[a-z0-9]*"
	}
};

export const role = {
	model: "role",
	label: "Role",
	type: "select",
	maxItems: 6,
	attrs: {
		placeholder: "Select one or more roles",
	},
	options: [
		{ value: "user", label: "User", title: "Can login and view journeys, no editing." },
		{ value: "driver", label: "Driver", title: "Can login and view journey. Can add/edit own journeys." },
		{ value: "operator", label: "Operator", title: "Can login, view, add and edit journeys." },
		{ value: "manager", label: "Manager", title: "Can login, view, add and edit journeys, locations and assets" },
		{ value: "admin", label: "Admin", title: "Can login, view, add and edit journeys, locations, assets and people. Can edit own organisation." },
		{ value: "master", label: "Master", title: "Full control over this site." }
	]
};

export const address = {
	model: "address",
	label: "Address",
	title: "Physical address or directions to this place",
	type: "text",
	hideEmpty: true,
	attrs: {
		placeholder: "Enter an address"
	}
};

export const geo = {
	model: "geo",
	label: "Position",
	title: "Geographical location",
	type: "geo",
	component: "jm-edit-geo"
};

export const registration = {
	model: "registration",
	label: "Registration",
	title: "Licence number or registration marks",
	type: "text",
	attrs: {
		placeholder: "Registration number or marks"
	}
};

export const description = {
	model: "description",
	label: "Description",
	title: "Brief description of main characteristics (e.g., colour marks)",
	type: "text",
	attrs: {
		placeholder: "Enter a brief description"
	}
};

export const state = {
	model: "state",
	label: "State",
	type: "select",
	hideEmpty: true,
	attrs: {
		placeholder: "Choose a state for this entity"
	},
	options: [
		{ value: "active", label: "Active", title: "Is active and can be used" },
		{ value: "inactive", label: "Inactive", title: "Is not active and cannot be used" },
	]
};



// WEBPACK FOOTER //
// ./src/services/components/list.js